import { useMutation } from "react-query";
import inviteUser from "../services/inviteUser";

const useInviteUser = () => {
  return useMutation(["invite-user"], inviteUser);
};

export default useInviteUser;
